import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

const fetchTestStepRecords = async (id) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getTsFromTcr&companyid=${user.companyid}&tcrid=${id}`,
  );

  return response.data;
};

const useTestStepSearchQuery = (id, options) => {
  return useQuery({
    queryKey: ["ReportsTestStepResults", id],
    queryFn: () => fetchTestStepRecords(id),
    enabled: options.enabled && id !== null,
  });
};

export default useTestStepSearchQuery;
